import {Injectable, OnDestroy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Subject} from 'rxjs';


interface WizardNestedFormServiceInterface {
    form: FormGroup;
    stopSubscribe$: Subject<any>;
    isFormTouched(): boolean;
    init(): void;
    setTouched(): void;
    /**
     * Метод, в котором будут восстанавливаться отстутствующие валидаторы полей
     */
    restoreValidators?(): void;
}

/**
 * Базовый сервис для управления вложенной формой визарда
 */

@Injectable()
export class WizardNestedFormService implements WizardNestedFormServiceInterface, OnDestroy {
    public form: FormGroup = new FormGroup({});

    public stopSubscribe$ = new Subject();
    public destroyed$ = new Subject();

    public isFormTouched(): boolean {
        try {
            return this.form.get('_touched').value;
        } catch (e) {
            return true;
        }
    }

    init() {

    }

    restoreValidators() {

    }

    setTouched(touched: boolean = true) {
        try {
            this.form.get('_touched').patchValue(touched);
        } catch (e) {
            /**
             * Ну, значит нет такого поля по какой-то причине
             */
        }
    }

    ngOnDestroy() {
        this.stopSubscribe$.next();
        this.destroyed$.next();
    }
}

